/**
 * This function takes a CSS value and converts it to pixels.
 *
 * @param cssValue A valid CSS value like '12px', '1.25rem' etc
 *
 * @returns The cssValue converted to pixels
 */
export function toPixels(cssValue, parentElement) {
    if (cssValue.includes('px')) {
        return parseCssValue(cssValue, 'px');
    }
    if (cssValue.includes('rem')) {
        const rootFontSize = Number.parseInt(getComputedStyle(document.documentElement).fontSize.split('px')[0], 10);
        const value = parseCssValue(cssValue, 'rem');
        return value * rootFontSize;
    }
    if (cssValue.includes('em')) {
        const root = parentElement ? parentElement : document.documentElement;
        const rootFontSize = Number.parseInt(getComputedStyle(root).fontSize.split('px')[0], 10);
        const value = parseCssValue(cssValue, 'em');
        return value * rootFontSize;
    }
    if (cssValue.includes('%')) {
        const root = parentElement ? parentElement : document.documentElement;
        const rootWidth = Number.parseInt(getComputedStyle(root).width.split('px')[0], 10);
        const value = parseCssValue(cssValue, '%');
        return (value * rootWidth) / 100;
    }
    if (cssValue.includes('vw')) {
        const viewPortWidth = window.innerWidth;
        const value = parseCssValue(cssValue, 'vw');
        return (viewPortWidth * value) / 100;
    }
    if (cssValue.includes('vh')) {
        const viewPortHeight = window.innerHeight;
        const value = parseCssValue(cssValue, 'vh');
        return (viewPortHeight * value) / 100;
    }
}
function parseCssValue(cssValue, cssUnit) {
    return Number.parseFloat(cssValue.split(cssUnit)[0]);
}
